import classnames from 'classnames';
import React, { CSSProperties, useEffect, useState } from 'react';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';

type TabSwitchProps = {
    className?: string;
    textClassName?: string;
    tabClassName?: string;
    activeTabClassName?: string;
    activeTabCss?: CSSProperties;
    state?: boolean;
    disabled?: boolean;
    offText?: string;
    onText?: string;
    offLeadingIcon?: React.JSX.Element;
    onLeadingIcon?: React.JSX.Element;
    onChange?: (state: boolean) => void;
};
export function TabSwitch(props: TabSwitchProps): React.JSX.Element {
    const {
        className,
        state,
        offText,
        onText,
        onChange,
        textClassName,
        activeTabClassName,
        activeTabCss,
        tabClassName
    } = props;

    const _offText = offText || '';
    const _onText = onText || '';
    function getActiveTabIndex(switchState: boolean): 0 | 1 {
        switch (switchState) {
            case true:
                return 1;
            default:
                return 0;
        }
    }

    function getStateFromActiveTabIndex(index: 0 | 1): boolean {
        switch (index) {
            case 1:
                return true;
            default:
                return false;
        }
    }

    const [activeId, setActiveId] = useState<number>(getActiveTabIndex(state));

    useEffect(() => {
        // eslint-disable-next-line react-hooks/set-state-in-effect -- intentional: sync local tab index when controlled state prop changes
        setActiveId(getActiveTabIndex(state));
    }, [state]);

    return (
        <Tabs
            className={className}
            defaultIndex={activeId}
            onSelect={(index) => onChange(getStateFromActiveTabIndex(index as 0 | 1))}>
            <TabList className="flex flex-row justify-items-stretch cursor-pointer whitespace-pre">
                <Tab
                    className={classnames(
                        'w-full px-12',
                        'tab-slider--new',
                        tabClassName,
                        activeId === 0 && (activeTabClassName || 'tab-slider--active'),
                        props.offLeadingIcon && 'flex flex-row items-center space-x-12'
                    )}
                    style={activeId === 0 ? activeTabCss : undefined}
                    onClick={() => onChange && onChange(false)}>
                    {props.offLeadingIcon}
                    {_offText && (
                        <span
                            className={classnames(
                                'font-montserrat-bold text-button-14 md:text-button-16',
                                textClassName
                            )}>
                            {_offText}
                        </span>
                    )}
                </Tab>
                <Tab
                    className={classnames(
                        'w-full px-12',
                        'text-button-14 md:text-button-16',
                        'tab-slider--new',
                        tabClassName,
                        activeId === 1 && (activeTabClassName || 'tab-slider--active'),
                        props.onLeadingIcon && 'flex flex-row items-center space-x-12'
                    )}
                    style={activeId === 1 ? activeTabCss : undefined}
                    onClick={() => onChange && onChange(true)}>
                    {props.onLeadingIcon}
                    {_onText && (
                        <span
                            className={classnames(
                                'font-montserrat-bold text-button-14 md:text-button-16',
                                textClassName
                            )}>
                            {_onText}
                        </span>
                    )}
                </Tab>
            </TabList>
            <TabPanel className="hidden"></TabPanel>
            <TabPanel className="hidden"></TabPanel>
        </Tabs>
    );
}
